import { Dialog, DialogDismiss, DialogHeading } from "@ariakit/react";
import { classNames } from "@indietabletop/appkit";
import type { RecipeVariants } from "@vanilla-extract/recipes";
import { type CSSProperties, type ReactNode } from "react";
import { CloseIcon } from "../PageHeaderButton/Icon.tsx";
import { actions, dialog, header, main } from "./dialog.css.ts";

type Falsy = false | null | undefined;

type ClassName = string | Falsy;

type StyledProps = {
  className?: ClassName;
  style?: CSSProperties;
};

function styled(props: StyledProps, ...classes: ClassName[]) {
  const returnProps: {
    className?: string | undefined;
    style?: CSSProperties | undefined;
  } = {
    className: classNames(props.className, ...classes),
  };

  if (props.style) {
    returnProps.style = props.style;
  }

  return returnProps;
}

export function DialogHeader(props: { heading: ReactNode }) {
  const { heading } = props;

  return (
    <div className={header.container}>
      <div />

      <DialogHeading className={header.heading}>{heading}</DialogHeading>

      <DialogDismiss className={header.action}>
        <CloseIcon />
      </DialogDismiss>
    </div>
  );
}

export function DialogActions(props: StyledProps & { children: ReactNode }) {
  return <div {...styled(props, actions.container)}>{props.children}</div>;
}

export function DialogContent(props: StyledProps & { children: ReactNode }) {
  return <div {...styled(props, main.content)}>{props.children}</div>;
}

export function ScrollableDialog(
  props: { children: ReactNode } & RecipeVariants<typeof dialog.container>,
) {
  const { children, isNarrow } = props;

  return (
    <Dialog
      modal
      backdrop={false}
      render={(props: React.HTMLAttributes<HTMLDivElement>) => {
        return (
          <div className={dialog.backdrop}>
            <div {...props} className={dialog.container({ isNarrow })} />
          </div>
        );
      }}
    >
      {children}
    </Dialog>
  );
}
